export default function Value(props) {

    if (props.isLeft) {
        return (
            <div className="our-value-item">
                <img src={props.img} alt="" />
                <div className="text-right">
                    <h2>
                        {props.title}
                    </h2>
                    <p>{props.desc}</p>
                </div>
            </div>
        )

    }

    return (
        <div className="our-value-item">
            <div className="text-left">
                <h2>
                    {props.title}
                </h2>
                <p>{props.desc}</p>
            </div>
            <img src={props.img} alt="" />
        </div>
    )
    
}